"use strict";

exports.__esModule = true;

var _AlignmentButton = _interopRequireDefault(require("./alignment/AlignmentButton"));

exports.AlignmentButton = _AlignmentButton["default"];

var _ListButton = _interopRequireDefault(require("./list/ListButton"));

exports.ListButton = _ListButton["default"];

var _FontsButton = _interopRequireDefault(require("./fonts/FontsButton"));

exports.FontsButton = _FontsButton["default"];

var _FontsSizeButton = _interopRequireDefault(require("./fonts/FontsSizeButton"));

exports.FontsSizeButton = _FontsSizeButton["default"];

var _FontsColorButton = _interopRequireDefault(require("./fonts/FontsColorButton"));

exports.FontsColorButton = _FontsColorButton["default"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }